import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M2 3C2 2.44772 2.44772 2 3 2H6C9.86599 2 13 5.13401 13 9V13.5858L14.7929 11.7929C15.1834 11.4024 15.8166 11.4024 16.2071 11.7929C16.5976 12.1834 16.5976 12.8166 16.2071 13.2071L12.3536 17.0607C12.1583 17.2559 11.8417 17.2559 11.6464 17.0607L7.79289 13.2071C7.40237 12.8166 7.40237 12.1834 7.79289 11.7929C8.18342 11.4024 8.81658 11.4024 9.20711 11.7929L11 13.5858V9C11 6.23858 8.76142 4 6 4H3C2.44772 4 2 3.55228 2 3ZM14 3C14 2.44772 14.4477 2 15 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V8C2 7.44772 2.44772 7 3 7C3.55228 7 4 7.44772 4 8V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H15C14.4477 4 14 3.55228 14 3Z"
  />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M1.935 2.50006C1.935 2.18802 2.18796 1.93506 2.5 1.93506H4.5C7.02118 1.93506 9.065 3.97888 9.065 6.50006V9.13603L10.6005 7.60054C10.8211 7.3799 11.1789 7.3799 11.3995 7.60054C11.6202 7.82119 11.6202 8.17893 11.3995 8.39957L8.85355 10.9455C8.65829 11.1408 8.34171 11.1408 8.14645 10.9455L5.60049 8.39957C5.37984 8.17893 5.37984 7.82119 5.60049 7.60054C5.82113 7.3799 6.17887 7.3799 6.39952 7.60054L7.935 9.13603V6.50006C7.935 4.60296 6.3971 3.06506 4.5 3.06506H2.5C2.18796 3.06506 1.935 2.8121 1.935 2.50006ZM9.935 2.50006C9.935 2.18802 10.188 1.93506 10.5 1.93506H11.5C12.9166 1.93506 14.065 3.08345 14.065 4.50006V11.5001C14.065 12.9167 12.9166 14.0651 11.5 14.0651H4.5C3.08339 14.0651 1.935 12.9167 1.935 11.5001V5.50006C1.935 5.18802 2.18796 4.93506 2.5 4.93506C2.81204 4.93506 3.065 5.18802 3.065 5.50006V11.5001C3.065 12.2926 3.70747 12.9351 4.5 12.9351H11.5C12.2925 12.9351 12.935 12.2926 12.935 11.5001V4.50006C12.935 3.70753 12.2925 3.06506 11.5 3.06506H10.5C10.188 3.06506 9.935 2.8121 9.935 2.50006Z"
  />
);

export const ImportIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Import" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
